import { Stack, Typography } from "@mui/material";
import { Trans } from "react-i18next";

interface StepTitleViewProps {
  title: string;
  productName?: string;
  descriptions?: string[] | null;
}

const StepTitleView = ({
  title,
  descriptions,
  productName,
}: StepTitleViewProps) => {
  return (
    <>
      <Stack alignItems="center" pb={3} direction="column" spacing={2}>
        <Typography variant="h3" textAlign="center">
          {title}
        </Typography>
        {productName && (
          <Typography variant="body2">
            <Trans i18nKey="onboarding.title.productName.label">
              You're signing up for <strong>{{ productName }}</strong>
            </Trans>
          </Typography>
        )}
        {descriptions && (
          <Stack direction="column" alignItems="center">
            {descriptions.map((description, i) => (
              <Typography key={i} variant="body2" textAlign="center">
                {description}
              </Typography>
            ))}
          </Stack>
        )}
      </Stack>
    </>
  );
};

export default StepTitleView;
